import { forwardRef, type SVGProps } from "react";

export const MenuIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="23"
        height="15"
        viewBox="0 0 23 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Menu</title>
        <path
          d="M21.8625 6.4502H0.8625C0.4125 6.4502 0 6.8252 0 7.3127C0 7.7627 0.375 8.1752 0.8625 8.1752H21.8625C22.3125 8.1752 22.725 7.80019 22.725 7.3127C22.725 6.8252 22.3125 6.4502 21.8625 6.4502Z"
          fill="currentColor"
        />
        <path
          d="M21.8625 12.8252H0.8625C0.4125 12.8252 0 13.2002 0 13.6877C0 14.1752 0.375 14.5502 0.8625 14.5502H21.8625C22.3125 14.5502 22.725 14.1752 22.725 13.6877C22.725 13.2002 22.3125 12.8252 21.8625 12.8252Z"
          fill="currentColor"
        />
        <path
          d="M0.8625 1.725H21.8625C22.3125 1.725 22.725 1.35 22.725 0.8625C22.725 0.375 22.35 0 21.8625 0H0.8625C0.4125 0 0 0.375 0 0.8625C0 1.35 0.4125 1.725 0.8625 1.725Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
MenuIcon.displayName = "MenuIcon";

export const SortIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Sort</title>
        <path
          d="M5.41667 17.0834V2.91675M5.41667 2.91675L2.5 5.83341M5.41667 2.91675L8.33333 5.83341"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5834 2.91658V17.0833M14.5834 17.0833L11.6667 14.1666M14.5834 17.0833L17.5 14.1666"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
SortIcon.displayName = "SortIcon";

export const SearchIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Search</title>
        <path
          d="M15.75 15.75L10.75 10.75M12.4167 6.58333C12.4167 9.80499 9.80499 12.4167 6.58333 12.4167C3.36167 12.4167 0.75 9.80499 0.75 6.58333C0.75 3.36167 3.36167 0.75 6.58333 0.75C9.80499 0.75 12.4167 3.36167 12.4167 6.58333Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
SearchIcon.displayName = "SearchIcon";

export const PlaySmallIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Play</title>
        <path
          d="M2.66675 3.06506V12.9343C2.66675 13.7041 3.50008 14.1852 4.16675 13.8003L12.7138 8.8657C13.3804 8.4808 13.3804 7.51855 12.7138 7.13365L4.16675 2.19903C3.50008 1.81413 2.66675 2.29526 2.66675 3.06506Z"
          fill="currentColor"
          stroke="currentColor"
        />
      </svg>
    );
  },
);
PlaySmallIcon.displayName = "PlaySmallIcon";

export const PinIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Pin</title>
        <path
          d="M8 13.9973V10.6875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3441 10.6883C12.2705 10.1099 12.081 9.232 11.5423 8.30938C11.2651 7.83442 10.9606 7.45876 10.6892 7.17163V3.65492C10.6892 2.74058 9.9486 2 9.03425 2H6.9656C6.05126 2 5.31068 2.74058 5.31068 3.65492V7.17163C5.03845 7.45876 4.73394 7.83442 4.45757 8.30938C3.91972 9.232 3.72941 10.1099 3.65576 10.6883H12.3441Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
PinIcon.displayName = "PinIcon";

export const DownloadIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Download</title>
        <path
          d="M2 9.56786V12C2 13.243 2.75736 14 4 14L12 14C13.2426 14 14 13.243 14 12V9.56786M10.9963 7.55537L7.99634 10.5563M7.99634 10.5563L4.99634 7.55537M7.99634 10.5563L7.99634 2"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
DownloadIcon.displayName = "DownloadIcon";

export const GiftWhiteIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ "aria-hidden": ariaHidden = true, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width="65"
        height="65"
        viewBox="0 0 65 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={ariaHidden}
        {...props}
      >
        <title>Gift</title>
        <path
          d="M53.834 32.5006V59.1673H11.1673V32.5006M32.5006 59.1673V19.1673M32.5006 19.1673H20.5007C18.7325 19.1673 17.0368 18.4649 15.7866 17.2147C14.5364 15.9645 13.834 14.2688 13.834 12.5007C13.834 10.7325 14.5364 9.03685 15.7866 7.78661C17.0368 6.53636 18.7325 5.83398 20.5007 5.83398C29.834 5.83398 32.5006 19.1673 32.5006 19.1673ZM32.5006 19.1673H44.5006C46.2688 19.1673 47.9645 18.4649 49.2147 17.2147C50.4649 15.9645 51.1673 14.2688 51.1673 12.5007C51.1673 10.7325 50.4649 9.03685 49.2147 7.78661C47.9645 6.53636 46.2688 5.83398 44.5006 5.83398C35.1673 5.83398 32.5006 19.1673 32.5006 19.1673ZM5.83398 19.1673H59.1673V32.5006H5.83398V19.1673Z"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
GiftWhiteIcon.displayName = "GiftWhiteIcon";
